import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v-pagination"
}
const _hoisted_2 = { class: "v-pagination__label" }
const _hoisted_3 = { class: "v-pagination__buttons" }
const _hoisted_4 = {
  key: 1,
  class: "spacer"
}

import { computed } from 'vue';
import ChevronLeftIcon from './icons/navigation/ChevronLeftIcon.vue';
import ChevronRightIcon from './icons/navigation/ChevronRightIcon.vue';
import VIconButton from './VIconButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VPagination',
  props: {
    meta: null
  },
  emits: [ "changepage" ],
  setup(__props: any, { emit }) {

const props = __props as { meta: { totalCount: number, pageCount: number, currentPage: number, perPage: number } }



const current = computed(() => (props.meta.currentPage-1) * props.meta.perPage + 1)
const to = computed(() => Math.min(props.meta.currentPage * props.meta.perPage, props.meta.totalCount))

const pageButtons = computed(() => {
  let startCount = 4
  let endCount = 2
  const arr: (number | null)[] = []

  if (window.innerWidth < 310) {
    endCount = 1
  }
  
  let start = Math.max(props.meta.currentPage - Math.trunc(startCount/2), 1)
  if (start + startCount >= props.meta.pageCount - endCount) {
    for (let i = Math.max(props.meta.pageCount - startCount-endCount, 1); i < props.meta.pageCount+1; i++) {
      arr.push(i)
    }
    return arr
  }
  
  for (let i = start; i < start+startCount; i++) {
    arr.push(i)
  }
  arr.push(null)
  for (let i = props.meta.pageCount-endCount+1; i < props.meta.pageCount+1; i++) {
    arr.push(i)
  }

  return arr
})



const incrementPage = (value: number) => {
  const newPage = props.meta.currentPage + value
  if (newPage < 1 || newPage > props.meta.pageCount) return
  emit("changepage", newPage)
}


return (_ctx: any,_cache: any) => {
  return (props.meta.pageCount > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(" Showing "),
          _createElementVNode("b", null, _toDisplayString(_unref(current)), 1),
          _createTextVNode(" to "),
          _createElementVNode("b", null, _toDisplayString(_unref(to)), 1),
          _createTextVNode(" of "),
          _createElementVNode("b", null, _toDisplayString(props.meta.totalCount), 1),
          _createTextVNode(" entries ")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(VIconButton, {
            disabled: props.meta.currentPage === 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (incrementPage(-1)))
          }, {
            default: _withCtx(() => [
              _createVNode(ChevronLeftIcon)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageButtons), (cell) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (cell !== null)
                ? (_openBlock(), _createBlock(VIconButton, {
                    key: 0,
                    class: _normalizeClass({ active: props.meta.currentPage === cell }),
                    onClick: ($event: any) => (emit('changepage', cell))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(cell), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, "..."))
            ], 64))
          }), 256)),
          _createVNode(VIconButton, {
            disabled: props.meta.currentPage === props.meta.pageCount,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (incrementPage(1)))
          }, {
            default: _withCtx(() => [
              _createVNode(ChevronRightIcon)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})